/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenu from '../../../components/shared/ActionsMenu'
import { useFsiActionMenu } from '../../../hooks/useFsiActionMenu'
import type { FilePlanItem } from '../../../services/api/etmf'

interface FilePlansTableMenuProps {
  item: FilePlanItem
}

/**
 * Actions menu for File Plans table
 * Uses the full useFsiActionMenu with clinicalFilePlan option
 * Migrated from lego/page/etmf/list/FilePlansTableMenu.jsx
 */
const FilePlansTableMenu: React.FC<FilePlansTableMenuProps> = ({ item }) => {
  const { items, setIsOpen } = useFsiActionMenu(item as any, { clinicalFilePlan: true })

  return (
    <ActionsMenu
      menuId={`action-menu-fileplans-${item.id}`}
      onToggle={(open) => {
        setIsOpen(open)
      }}
      items={items}
    />
  )
}

export default FilePlansTableMenu
